import { HeuristicScore } from '@/api/types'

export function getTotalHeuristicsScore(heuristicScores: Array<HeuristicScore>) {
  return heuristicScores.reduce((acc, score) => acc + score.weight * score.value, 0).toFixed(2)
}
